/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGearOn = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12 14a2 2 0 0 0 1.491-3.333l1.49-1.334a4 4 0 1 1-5.962 0l1.49 1.334A2 2 0 0 0 12 14z" />
        <path d="M13 8h-2v4h2z" />
        <path d="M9 2h6v2.584l.123.05 1.827-1.826 4.242 4.242-1.827 1.827.05.123H22v6h-2.584a9.295 9.295 0 0 1-.05.123l1.827 1.827-4.243 4.242-1.827-1.827-.123.05V22H9v-2.584a7.733 7.733 0 0 1-.123-.05L7.05 21.191 2.808 16.95l1.827-1.827a7.923 7.923 0 0 1-.05-.123H2V9h2.584l.05-.123L2.809 7.05 7.05 2.808l1.827 1.827.123-.05zm2 2v2.04l-.716.213a5.93 5.93 0 0 0-1.138.468l-.656.356-1.44-1.44L5.636 7.05l1.44 1.44-.355.656a5.93 5.93 0 0 0-.468 1.138L6.04 11H4v2h2.04l.213.716c.119.4.276.782.468 1.138l.356.656-1.44 1.44 1.413 1.414 1.44-1.44.656.355c.356.192.737.35 1.138.468l.716.213V20h2v-2.04l.716-.213a5.923 5.923 0 0 0 1.138-.468l.656-.356 1.44 1.44 1.415-1.413-1.44-1.44.355-.656a6.05 6.05 0 0 0 .469-1.14l.213-.714H20v-2h-2.04l-.213-.716a5.924 5.924 0 0 0-.468-1.138l-.356-.656 1.44-1.44-1.413-1.414-1.44 1.44-.656-.355a5.928 5.928 0 0 0-1.138-.468L13 6.04V4z" />
      </g>
    </g>
  </Icon>
);
export { SvgGearOn as GearOn };
